import styled, { css } from 'styled-components';

interface IMessageProps {
  $isOwner: boolean;
}
export const AreaComment = styled.div<IMessageProps>`
  display: flex;
  flex-direction: column;
  margin: 0 auto 0 0;

  ${({ $isOwner }) =>
    $isOwner &&
    css`
      margin: 0 0 0 auto;
    `}
`;

export const Message = styled.div<IMessageProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 12px 30px 12px 12px;
  color: ${({ theme }) => theme.icon};
  background-color: #f1f1f1;
  border-radius: 10px;
  width: 100%;
  min-width: 300px;
  max-width: 400px;
  overflow: hidden;
  word-break: break-word;
  white-space: pre-wrap;

  ${({ $isOwner }) =>
    $isOwner &&
    css`
      background-color: #ebeef9;
    `};
`;

export const MessageReply = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  padding: 10px 4px;
  font-size: 12px;
  color: rgb(126, 126, 126);
  background-color: rgb(222 229 255);
  border-radius: 0px 6px 6px 0px;
  width: 100%;
  max-width: 300px;
  border-left: 1px solid #3f5ec9;
  margin: 0 0 10px 0;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
`;

export const AreaButtons = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

export const FooterMessage = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  line-height: 12px;
  color: ${({ theme }) => theme.icon};
  gap: 1rem;
`;
export const FooterMessageLeft = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 2px;
`;
export const FooterMessageRight = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 2px;
`;

export const NameSender = styled.span`
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AreaRenderTooltipMessage = styled.div`
  display: flex;
  flex-direction: column;
  white-space: pre-wrap;
`;

